import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import moment from 'moment';

if (window.accessToken) {
  window.localStorage.setItem('webclientauthentication', JSON.stringify({
    accessToken: window.accessToken,
    loggedIn: true,
    expiresIn: 7200,
    expiresAt: moment().add(7200 - 60, 's').toDate(),
  }));
}

const INITIAL_STATE = Immutable({
  user: {},
  jobs: [],
  refreshToken: '',
  accessToken: '',
  expiresIn: 0,
  loggedIn: false,
  loading: false,
  errorMessage: null,
  isLoadingConfiguration: false,
  config: {},
  organizationNameAvailable: true,
});

export const login = createAction('LOGIN');
export const logout = createAction('LOGOUT');
export const loginSucceeded = createAction('LOGIN_SUCCEEDED');
export const loginFailed = createAction('LOGIN_FAILED');
export const authorizeAction = createAction('AUTHORIZE');

export const externalLoginAction = createAction('EXTERNAL_LOGIN');
export const externalLoginSuccessAction = createAction('EXTERNAL_LOGIN_SUCCESS');
export const externalLoginFailedAction = createAction('EXTERNAL_LOGIN_FAILED');

export const signup = createAction('SIGNUP');
export const signupSucceeded = createAction('SIGNUP_SUCCEEDED');
export const signupFailed = createAction('SIGNUP_FAILED');

export const platformSignup = createAction('PLATFORM_SIGNUP');
export const platformSignupSucceeded = createAction('PLATFORM_SIGNUP_SUCCESS');
export const platformSignupFailed = createAction('PLATFORM_SIGNUP_FAILED');

export const signupMultiple = createAction('SIGNUP_MULTIPLE');
export const signupMultipleSucceeded = createAction('SIGNUP_MULTIPLE_SUCCESS');
export const signupMultipleFailed = createAction('SIGNUP_MULTIPLE_FAILED');

export const requestResetPassword = createAction('REQUESTRESETPASSWORD');
export const requestResetPasswordSucceeded = createAction('REQUESTRESETPASSWORDSUCCEEDED');
export const requestResetPasswordFailed = createAction('REQUESTRESETPASSWORDFAILED');

export const resetPassword = createAction('RESETPASSWORD');
export const resetPasswordSucceeded = createAction('RESETPASSWORD_SUCCEEDED');
export const resetPasswordFailed = createAction('RESETPASSWORD_FAILED');

export const refreshTokenSucceeded = createAction('REFRESH_TOKEN_SUCCEEDED');
export const refreshTokenFailed = createAction('REFRESH_TOKEN_FAILED');

export const loadJobs = createAction('LOAD_JOBS');
export const loadJobsSucceeded = createAction('LOAD_JOBS_SUCCEEDED');
export const loadJobsFailed = createAction('LOAD_JOBS_FAILED');

export const loadUserInfo = createAction('LOAD_USER_INFO');
export const loadUserInfoSucceeded = createAction('LOAD_USER_INFO_SUCCESS');
export const loadUserInfoFailed = createAction('LOAD_USER_INFO_FAILED');

export const onChangePassword = createAction('CHANGE_PASSWORD');
export const onChangePasswordSuccess = createAction('CHANGE_PASSWORD_SUCCESS');
export const onChangePasswordFailed = createAction('CHANGE_PASSWORD_FAILED');

export const onChangeUserData = createAction('CHANGE_UNSER_INFO');
export const onChangeUserDataSuccess = createAction('CHANGE_USER_INFO_SUCCESS');
export const onChangeUserDataFailed = createAction('CHANGE_USER_INFO_FAILED');

export const onLoadConfiguration = createAction('ON_LOAD_CONFIGURATION');
export const onLoadConfigurationSuccess = createAction('ON_LOAD_CONFIGURATION_SUCCESS');
export const onLoadConfigurationFailed = createAction('ON_LOAD_CONFIGURATION_FAILED');

export const loadUserGroupsForUserAction = createAction('LOAD_USER_GROUPS');
export const loadUserGroupsForUserSuccessAction = createAction('LOAD_USER_GROUPS_SUCCESS');
export const loadUserGroupsForUserFailedAction = createAction('LOAD_USER_GROUPS_FAILED');

export const loadUserRolesAction = createAction('LOAD_USER_ROLES', 'userRoles');
export const loadUserRolesSuccessAction = createAction('LOAD_USER_ROLES_SUCCESS');
export const loadUserRolesFailedAction = createAction('LOAD_USER_ROLES_FAILED');

export const checkOrganizationNameAvailableAction = createAction('CHECK_ORGANIZATION_AVAILABLE');
export const checkOrganizationNameAvailableSuccessAction = createAction('CHECK_ORGANIZATION_AVAILABLE_SUCCEEDED');


const reducers = createReducer({
  [login]: state => state.merge({
    errorMessage: null,
    loading: true,
  }),
  [signup]: state => state.merge({
    errorMessage: null,
    loading: true,
  }),
  [platformSignup]: state => state.merge({
    errorMessage: null,
    loading: true,
  }),
  [signupSucceeded]: state => state.merge({
    errorMessage: null,
    loading: false,
  }),
  [signupFailed]: (state, { message }) => state.merge({
    errorMessage: message,
    accessToken: null,
    refreshToken: null,
    expiresIn: 0,
    user: {},
    loading: false,
    loggedIn: false,
  }),
  [requestResetPassword]: state => state.merge({
    errorMessage: null,
    loading: true,
  }),
  [requestResetPasswordSucceeded]: state => state.merge({
    errorMessage: null,
    loading: false,
  }),
  [requestResetPasswordFailed]: (state, { message }) => state.merge({
    errorMessage: message,
    loading: false,
  }),
  [resetPassword]: state => state.merge({
    errorMessage: null,
    loading: true,
  }),
  [resetPasswordSucceeded]: state => state.merge({
    errorMessage: null,
    loading: false,
  }),
  [resetPasswordFailed]: (state, { message }) => state.merge({
    errorMessage: message,
    accessToken: null,
    refreshToken: null,
    expiresIn: 0,
    user: {},
    loading: false,
    loggedIn: false,
  }),
  [logout]: () => INITIAL_STATE,
  [loginSucceeded]: (state, { refreshToken, accessToken, expiresIn }) => state.merge({
    loggedIn: true,
    refreshToken,
    accessToken,
    expiresIn,
    expiresAt: moment().add(expiresIn - 60, 's').toDate(),
    errorMessage: null,
    loading: false,
  }),
  [loginFailed]: (state, { message }) => state.merge({
    errorMessage: message,
    accessToken: null,
    refreshToken: null,
    expiresIn: 0,
    user: {},
    loading: false,
    loggedIn: false,
  }),
  [refreshTokenSucceeded]: (state, { refreshToken, accessToken, expiresIn }) => state.merge({
    loggedIn: true,
    refreshToken,
    accessToken,
    expiresIn,
    expiresAt: moment().add(expiresIn - 60, 's').toDate(),
    errorMessage: null,
    loading: false,
  }),
  [refreshTokenFailed]: (state, { message }) => state.merge({
    errorMessage: message,
    accessToken: null,
    refreshToken: null,
    expiresIn: 0,
    user: {},
    loading: false,
    loggedIn: false,
  }),
  [loadJobsSucceeded]: (state, { jobs }) => state.merge({
    jobs,
  }),
  [onChangePasswordFailed]: (state, errorMessage) => state.merge({ errorMessage }),
  [onChangePasswordSuccess]: state => state.merge({ errorMessage: null }),
  [loadUserInfoSucceeded]: (state, user) => state.merge({ user }),
  [onLoadConfiguration]: state => state.merge({ isLoadingConfiguration: true }),
  [onLoadConfigurationSuccess]: (state, config) => state.merge({ isLoadingConfiguration: false, config }),
  [onLoadConfigurationFailed]: state => state.merge({ isLoadingConfiguration: false }),
  [loadUserGroupsForUserSuccessAction]: (state, userGroups) => state.merge({ userGroups }),
  [loadUserRolesSuccessAction]: (state, roles) => state.merge({ roles }),
  [checkOrganizationNameAvailableSuccessAction]: (state, available) => state.merge({
    organizationNameAvailable: available,
  }),

}, INITIAL_STATE);

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/auth.reducers.js